import { render } from "./DownloadHeader.vue?vue&type=template&id=6ec8f5ff&scoped=true"
const script = {}

import "./DownloadHeader.vue?vue&type=style&index=0&id=6ec8f5ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec8f5ff"]])

export default __exports__